/**
 * @file 会员订阅弹窗UI层面类型定义
 */
import type {SubscriptionType} from '@/services/commerce/type';

/**
 * 会员订阅tab
 */
// 订阅tab
export interface SubscriptionTab {
    label: string;
    value: SubscriptionType;
    tag: string;
}

/**
 * 定义会员订阅弹窗来源类型
 */

export const MembershipModalSource = {
    // 积分不足提醒弹窗_开通_升级会员btn
    INSUFFICIENT_POINTS_REMINDER_POPUP_MEMBERSHIP_BTN:
        'insufficient_points_reminder_popup_membership_btn',
    // 积分不足提醒卡片_开通_升级会员btn
    INSUFFICIENT_POINTS_REMINDER_CARD_MEMBERSHIP_BTN:
        'insufficient_points_reminder_card_membership_btn',
    // 积分消耗详情页弹窗
    POINTS_CONSUMPTION_DETAILS_PAGE_POPUP_MEMBERSHIP_BTN:
        'points_consumption_details_page_popup_membership_btn',
    // 首页_个人头像面板
    HOME_PERSONAL_AVATAR_PANEL_MEMBERSHIP_BTN: 'home_personal_avatar_panel_membership_btn',
    // 首页_剧本创作_Hover
    HOME_SCRIPT_CREATION_HOVER_POPUP_MEMBERSHIP_BTN:
        'home_script_creation_hover_popup_membership_btn',
    // 首页侧边栏_开通_升级会员btn
    HOME_SIDEBAR_MEMBERSHIP_BTN: 'home_sidebar_membership_btn',
    // 订阅管理_订单历史页_开通_升级会员btn
    SUBSCRIPTION_MANAGEMENT_ORDER_HISTORY_PAGE_MEMBERSHIP_BTN:
        'subscription_management_order_history_page_membership_btn',
    // 工作空间_人员管理_开通_升级会员btn
    WORKSPACE_PERSONNEL_MANAGEMENT_MEMBERSHIP_BTN: 'workspace_personnel_management_membership_btn',
    // 工作空间_人员管理_Hover
    WORKSPACE_PERSONNEL_MANAGEMENT_HOVER_POPUP_MEMBERSHIP_BTN:
        'workspace_personnel_management_hover_popup_membership_btn',
    // 艺术指导_自定义样式_上传或拖拽参考图片按钮
    ART_DIRECTION_CUSTOM_STYLE_UPLOAD_OR_DRAG_REFERENCE_IMAGE_BTN:
        'art_direction_custom_style_upload_or_drag_reference_image_btn',
    // 艺术指导_自定义样式_Hover
    ART_DIRECTION_CUSTOM_STYLE_HOVER_POPUP_MEMBERSHIP_BTN:
        'art_direction_custom_style_hover_popup_membership_btn',
    // 画布_图片超高清分辨率_Hover
    CANVAS_IMAGE_ULTRA_HD_RESOLUTION_HOVER_POPUP_MEMBERSHIP_BTN:
        'canvas_image_ultra_hd_resolution_hover_popup_membership_btn',
    // 画布_视频超高清分辨率_Hover
    CANVAS_VIDEO_ULTRA_HD_RESOLUTION_HOVER_POPUP_MEMBERSHIP_BTN:
        'canvas_video_ultra_hd_resolution_hover_popup_membership_btn',
    // 画布_素材库_模板_Hover
    CANVAS_ASSET_LIBRARY_TEMPLATE_HOVER_POPUP_MEMBERSHIP_BTN:
        'canvas_asset_library_template_hover_popup_membership_btn',
    // 画布_图片生成器_模型选择
    CANVAS_IMAGE_GENERATOR_MODEL_SELECTION_MEMBERSHIP_BTN:
        'canvas_image_generator_model_selection_membership_btn',
    // 画布_视频生成器_模型选择
    CANVAS_VIDEO_GENERATOR_MODEL_SELECTION_MEMBERSHIP_BTN:
        'canvas_video_generator_model_selection_membership_btn',
    // AGENT 代理模型选择
    AGENT_MODEL_SELECTION_MEMBERSHIP_BTN: 'agent_model_selection_membership_btn',
} as const;

export type MembershipModalSourceType =
    (typeof MembershipModalSource)[keyof typeof MembershipModalSource];
